import { apiCall } from './gqlClient';

const GETPROVIDERBUNDLES_QUERY = `
  query getProviderBundles {
    getProviderBundles
    {
      id
			userBundleId
			name
			description
			price
			duration
			durationType
			isRecurring
			active
			providerId
      ...fragments
    }
  }`;

export const getProviderBundlesApiCall = async (fragments = null) => apiCall({ query: GETPROVIDERBUNDLES_QUERY, variables: {}, fragments });

const GETUSERBUNDLES_QUERY = `
  query getUserBundles($userId: Int, $customerId: Int) {
    getUserBundles(userId: $userId, customerId: $customerId)
    {
      id
			userBundleId
			name
			description
			price
			duration
			durationType
			isRecurring
			active
			providerId
      ...fragments
    }
  }`;

export const getUserBundlesApiCall = async ({userId, customerId}, fragments = null) => apiCall({ query: GETUSERBUNDLES_QUERY, variables: {userId, customerId}, fragments });

const GETMYBUNDLES_QUERY = `
  query getMyBundles {
    getMyBundles
    {
      id
			userBundleId
			name
			description
			price
			duration
			durationType
			isRecurring
			active
			providerId
      ...fragments
    }
  }`;

export const getMyBundlesApiCall = async (fragments = null) => apiCall({ query: GETMYBUNDLES_QUERY, variables: {}, fragments });

const GETBUNDLEBYID_QUERY = `
  query getBundleById($id: String!) {
    getBundleById(id: $id)
  }`;

export const getBundleByIdApiCall = async ({id}, ) => apiCall({ query: GETBUNDLEBYID_QUERY, variables: {id}});

const GETUSERBUNDLEBYID_QUERY = `
  query getUserBundleById($id: String!) {
    getUserBundleById(id: $id)
  }`;

export const getUserBundleByIdApiCall = async ({id}, ) => apiCall({ query: GETUSERBUNDLEBYID_QUERY, variables: {id}});

const GETBUNDLEITEMS_QUERY = `
  query getBundleItems($id: String!) {
    getBundleItems(id: $id)
  }`;

export const getBundleItemsApiCall = async ({id}, ) => apiCall({ query: GETBUNDLEITEMS_QUERY, variables: {id}});

const GETCUSTOMERBUNDLEITEMS_QUERY = `
  query getCustomerBundleItems($userBundleId: String!) {
    getCustomerBundleItems(userBundleId: $userBundleId)
  }`;

export const getCustomerBundleItemsApiCall = async ({userBundleId}, ) => apiCall({ query: GETCUSTOMERBUNDLEITEMS_QUERY, variables: {userBundleId}});

const GETMYBUNDLEITEMS_QUERY = `
  query getMyBundleItems($userBundleId: String!) {
    getMyBundleItems(userBundleId: $userBundleId)
  }`;

export const getMyBundleItemsApiCall = async ({userBundleId}, ) => apiCall({ query: GETMYBUNDLEITEMS_QUERY, variables: {userBundleId}});

const GETPROVIDERMEMBERSHIPBUNDLES_QUERY = `
  query getProviderMembershipBundles {
    getProviderMembershipBundles
  }`;

export const getProviderMembershipBundlesApiCall = async () => apiCall({ query: GETPROVIDERMEMBERSHIPBUNDLES_QUERY, variables: {}});

const CHECKBUNDLEOVERLAP_QUERY = `
  query checkBundleOverlap($bundleId: String!, $userId: Int, $customerId: Int) {
    checkBundleOverlap(bundleId: $bundleId, userId: $userId, customerId: $customerId)
    {
      hasOverlap
      ...fragments
    }
  }`;

export const checkBundleOverlapApiCall = async ({bundleId, userId, customerId}, fragments = null) => apiCall({ query: CHECKBUNDLEOVERLAP_QUERY, variables: {bundleId, userId, customerId}, fragments });

const GETALLMEMBERSHIPSASSIGNEDTOABUNDLE_QUERY = `
  query getAllMembershipsAssignedToABundle {
    getAllMembershipsAssignedToABundle
  }`;

export const getAllMembershipsAssignedToABundleApiCall = async () => apiCall({ query: GETALLMEMBERSHIPSASSIGNEDTOABUNDLE_QUERY, variables: {}});

const CREATEMEMBERSHIPBUNDLE_QUERY = `
  mutation createMembershipBundle($request: BundleMembershipInput!) {
    createMembershipBundle(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const createMembershipBundleApiCall = async ({request}, fragments = null) => apiCall({ query: CREATEMEMBERSHIPBUNDLE_QUERY, variables: {request}, fragments });

const UPDATEBUNDLE_QUERY = `
  mutation updateBundle($request: BundleUpdateInput!) {
    updateBundle(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const updateBundleApiCall = async ({request}, fragments = null) => apiCall({ query: UPDATEBUNDLE_QUERY, variables: {request}, fragments });

const TOGGLEBUNDLESTATUS_QUERY = `
  mutation toggleBundleStatus($id: String!, $value: Boolean!) {
    toggleBundleStatus(id: $id, value: $value)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const toggleBundleStatusApiCall = async ({id, value}, fragments = null) => apiCall({ query: TOGGLEBUNDLESTATUS_QUERY, variables: {id, value}, fragments });

const SETUSERBUNDLESTATUS_QUERY = `
  mutation setUserBundleStatus($userBundleId: String!, $isActive: Boolean!) {
    setUserBundleStatus(userBundleId: $userBundleId, isActive: $isActive)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const setUserBundleStatusApiCall = async ({userBundleId, isActive}, fragments = null) => apiCall({ query: SETUSERBUNDLESTATUS_QUERY, variables: {userBundleId, isActive}, fragments });

const ARCHIVEBUNDLE_QUERY = `
  mutation archiveBundle($id: String!) {
    archiveBundle(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const archiveBundleApiCall = async ({id}, fragments = null) => apiCall({ query: ARCHIVEBUNDLE_QUERY, variables: {id}, fragments });

const ADDMEMBERSHIPBUNDLETOUSER_QUERY = `
  mutation addMembershipBundleToUser($request: AddMembershipBundleInput!) {
    addMembershipBundleToUser(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const addMembershipBundleToUserApiCall = async ({request}, fragments = null) => apiCall({ query: ADDMEMBERSHIPBUNDLETOUSER_QUERY, variables: {request}, fragments });
